<template>
  <!--  事项单/会签单工作量核定单-->
  <div style="width:100%">

    <van-collapse v-model="activeNames">
      <van-collapse-item title="单价核定单" name="1">
        <van-field v-model="inputForm.contractCode" :label="`${formName}编号`" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractName" :label="isHq?'会签事项':'事项单名称'" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.budgetItemsName" label="所属项目" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractPartyJiaName" label="付款公司" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractPartyYiSupplierName" label="受款人名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.estimateAmount" label="核定总额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.estimateDate" label="核定区间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.unitCategoryName" label="单价类型" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.budgetAnnual" label="预算年度" v-if="inputForm.budgetControl === '1'||inputForm.budgetAnnualId!=='0'" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorName" label="经办人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorDeptName" label="经办部门" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px; margin-bottom: 10px; margin-top: 10px">
          <p style="display: block; color: #4caedc" @click="viewWorkloadEstimateDetail()">{{`查看${formName}工作量核定明细`}}</p>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import QueryInfoService from '@/api/system/queryInfoService'
import Decimal from "decimal.js";
export default {
  name: "eventWorkloadEstimate",
  data(){
    return {
      activeNames: ['1'],
      inputForm:{
        id:'',
        contractCode:'',
        contractName:'',
        budgetItemsName:'',
        contractPartyJiaName:'',
        contractPartyYiSupplierName:'',
        estimateAmount:'',
        estimateDate:'',
        unitCategory:'',
        unitCategoryName:'',
        budgetAnnual:'',
        budgetAnnualId:'',
        operatorName:'',
        operatorDeptName:'',
        createByName:'',
        createDate:'',
        workloadEstimateDetailList:[],
        isHq:'',
      }
    }
  },
  computed: {
    isHq() {
      if (this.inputForm && this.inputForm.isHq === '1') {
        return true;
      } else {
        return false;
      }
    },
    formName() {
      if (this.inputForm && this.inputForm.isHq === '1') {
        return "会签单";
      } else {
        return "事项单";
      }
    }
  },
  created() {
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    init(data) {
      this.$nextTick(()=>{
        this.inputForm = data
        // 金额校验
        this.inputForm.estimateAmount = Number(this.inputForm.estimateAmount).toFixed(2)
        // 日期校验
        this.inputForm.createDate =  this.inputForm.createDate.slice(0,10)
        if(data.estimateDateStart && data.estimateDateEnd) {
          this.inputForm.estimateDate = data.estimateDateStart  + '至' + data.estimateDateEnd
        }
        //查询字典
        this.getDict([['cost_contract_unit_category', 'unitCategory']])
        // 百分比校验
        if(data.unitCategory === '2') {
          this.inputForm.workloadEstimateDetailList.forEach(item => {
            item.unitPrice = new Decimal(item.unitPrice).mul(100).toFixed(2, Decimal.ROUND_HALF_UP)
          })
        }
      })
    },
    // 数据字典获取
    getDict(dicts){
      dicts.map(([dictType, formField]) => {
        new QueryInfoService().getDictMap().then(({data}) => {
          this.$set(this.inputForm, `${formField}Name`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        }).catch(e => {
          console.log(e)
        })
      });
    },
    viewWorkloadEstimateDetail() {
      this.$router.push({
        path: '/cost_event_workload_estimate_detail',
        query: {
          unitCategory: this.inputForm.unitCategory,
          data: JSON.stringify(this.inputForm.workloadEstimateDetailList)
        }
      })
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.unitTitle {
  width: 100%;
  padding-left: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.m-form {
  width: 100%;
  /*padding: 10px;*/
  font-size: 12px;
  box-sizing: border-box;
  /*border-bottom: 1px solid #eee;*/
  padding-left: 16px;
  margin-bottom: 10px;
}
.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  display: flex;
  width: calc(100%);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row:last-child {
  border-bottom: 1px solid #eee;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #dedede;*/
}

.m-row-content {
  width: calc(100% - 110px);
  color: black;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100% - 110px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>
